(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (!section || section.dataset.initialized === 'true') return;

      const track = section.querySelector('[data-track]');
      const dots = section.querySelectorAll('[data-dot]');
      const slides = section.querySelectorAll('[data-slide]');

      if (!track || dots.length === 0 || slides.length < 2) return;

      // Only activate slider behavior if the slider class is present.
      if (!track.classList.contains('image-row__track--mobile-slider')) return;

      // Click a dot → scroll to that slide
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const target = slides[index];
          if (!target) return;
          track.scrollTo({
            left: target.offsetLeft - track.offsetLeft,
            behavior: 'smooth'
          });
        });
      });

      // Observe which slide is in view, update active dot
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              const index = Array.from(slides).indexOf(entry.target);
              if (index === -1) return;
              dots.forEach((d) => d.classList.remove('is-active'));
              if (dots[index]) dots[index].classList.add('is-active');
            }
          });
        },
        {
          root: track,
          threshold: [0.5, 0.75, 1]
        }
      );

      slides.forEach((slide) => observer.observe(slide));

      section.dataset.initialized = 'true';
    }

    function initAll(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-image-row]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class IngredientCard {
      constructor(card) {
        this.card = card;
        this.triggers = card.querySelectorAll('[data-flip-trigger]');
        this.frontTrigger = card.querySelector('.ingredient-card__face--front [data-flip-trigger]');
        this.frontFace = card.querySelector('.ingredient-card__face--front');
        this.backFace = card.querySelector('.ingredient-card__face--back');
        this.isFlipped = false;

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggle();
          });
        });

        this.card.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.isFlipped) {
            this.toggle();
            if (this.frontTrigger) this.frontTrigger.focus();
          }
        });
      }

      toggle() {
        this.isFlipped = !this.isFlipped;
        this.card.classList.toggle('is-flipped', this.isFlipped);

        if (this.frontTrigger) {
          this.frontTrigger.setAttribute('aria-expanded', String(this.isFlipped));
        }
        if (this.frontFace) {
          this.frontFace.setAttribute('aria-hidden', String(this.isFlipped));
        }
        if (this.backFace) {
          this.backFace.setAttribute('aria-hidden', String(!this.isFlipped));
        }
      }
    }

    function init(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-ingredient-card].ingredient-card--flippable').forEach((card) => {
        if (!card.dataset.initialized) {
          new IngredientCard(card);
          card.dataset.initialized = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('[data-ingredient-card]');
      if (card && card.classList.contains('ingredient-card--flippable')) {
        card.classList.add('is-flipped');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
